import React from 'react'
import ErrorComponent from './ErrorComponent'

class ErrorPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidUpdate(prevProps, prevState) {
    const { hasError } = this.state
    if (hasError) {
      // Handle error
    }
  }

  componentDidCatch(error, info) {
    // track error
    console.error('error', error, info)
  }

  render() {
    const { hasError } = this.state
    if (hasError) {
      return <ErrorComponent />
    }

    const { children } = this.props
    return children
  }
}

export default ErrorPage
